import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Select, { components } from "react-select";

import axios from "axios";

import { LayoutContext, ToastContext } from "common/contexts";
import getGAUserID from "common/fetch/getGAUserID";
import sendData from "common/fetch/post";
import trigger from "common/trigger";

import ButtonNew from "components/atoms/ButtonNew/index";
import { BiLoaderAlt } from "components/atoms/Icon/bi/BiLoaderAlt";
import { FiChevronDown } from "components/atoms/Icon/fi/FiChevronDown";
import { FiSearch } from "components/atoms/Icon/fi/FiSearch";
import Img from "components/atoms/Img";
import ReCaptcha from "components/atoms/Recaptcha/index";

import styles from "./Index.module.scss";

const customSelectStyles = {
  control: (base) => ({
    ...base,
    height: 40,
    minHeight: 40,
    fontSize: "14px",
    cursor: "pointer",
    borderRadius: "30px",
  }),
  menu: (base) => ({
    ...base,
    fontSize: "14px",
    margin: 0,
  }),
  valueContainer: (base) => ({
    ...base,
    color: "#B7B7B7",
    margin: 0,
    padding: 0,
  }),
  singleValue: (base) => ({
    ...base,
    color: "#888888",
    padding: 0,
    height: "24px",
    margin: "8px 16px",
  }),
  option: (base, { isSelected }) => ({
    ...base,
    color: isSelected ? "white" : "#333",
  }),
};
const customSelectStylesNation = {
  control: (base) => ({
    ...base,
    height: 42,
    minHeight: 42,
    fontSize: "14px",
    margin: "0 8px",
  }),
  menu: (base) => ({
    ...base,
    fontSize: "14px",
  }),
};
// Dropdown

const Dropdown = ({ children, isOpen, target, onClose }) => (
  <div className="relative bg-bbc-white">
    {target}
    {isOpen ? (
      <div
        className="absolute z-20 w-full rounded-sm bg-bbc-white pt-2 shadow-lg"
        style={{ height: "70px" }}
      >
        {children}
      </div>
    ) : null}
    {isOpen ? (
      <div
        className="fixed bottom-0 left-0 top-0 right-0 z-10"
        onClick={onClose}
      />
    ) : null}
  </div>
);

const IconSearch = () => <FiSearch className=" mr-2 text-bbc-neutral-700" />;

const CustomOption = (props) => (
  <components.Option {...props}>
    <div className="flex cursor-pointer items-center">
      <Img
        style={{ marginRight: 8, width: 25, height: 18 }}
        src={`/assets/flags/4x3/${props.data.country_code.toLowerCase()}.svg`}
        alt={`${props.data.name.toLowerCase()} flag`}
      />
      <span className="text-sm">{props.data.name}</span>
    </div>
  </components.Option>
);

const CustomOptionDropdown = (props) => (
  <components.Option {...props}>
    <div>
      <span className="cursor-pointer text-sm">{props.data.name}</span>
    </div>
  </components.Option>
);
const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props} className="m-0 mr-4 !p-0">
    <FiChevronDown className=" text-base text-bbc-gray" />
  </components.DropdownIndicator>
);
// Let dropArrow = "scale(0.7)";
const arrowDown = () => {
  // DropArrow = "scale(0.7)";
};

const FormCheckNameCompany = ({ data }) => {
  const dataNotJersey = data?.data?.filter((item) => item.id !== 111);
  const { locationRouter } = useContext(LayoutContext);
  const countryList = dataNotJersey.map((item) => ({
    ...item,
    value: item.name,
  }));

  const countryListLocation = () => {
    let dataCountryFilter = {};

    if (locationRouter === "offshore") {
      dataCountryFilter = dataNotJersey?.map((item) => ({
        ...item,
        value: item.name,
      }));
    } else if (locationRouter === "hk") {
      dataCountryFilter = dataNotJersey?.filter((word) => word.id === 98);
    } else if (locationRouter === "sg") {
      dataCountryFilter = dataNotJersey?.filter((word) => word.id === 191);
    }

    return dataCountryFilter;
  };

  const countryInit = countryListLocation()[0];
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const recaptchaRef = useRef();
  const {
    register,
    handleSubmit,
    reset,
    clearErrors,
    formState: { isSubmitting, errors },
  } = useForm();

  const { openAlert } = useContext(ToastContext);

  /** * Get Data Country ***/

  const [country, setCountry] = React.useState(countryInit);

  const handedOnchange = (newCountry) => {
    setCountry(newCountry);
    setOpen(!isOpen);
  };

  /** * Get Data EntityType ***/

  const dataEntityType = country?.EntityTypes?.map((item) => ({
    ...item,
    value: item.name,
    label: item.name,
  }));

  const [entity, setEntity] = useState(dataEntityType[0]);

  useEffect(() => {
    if (country) {
      if (dataEntityType.length > 0) {
        setEntity(dataEntityType[0]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country]);

  const onSelectEntity = (newEntity) => {
    setEntity(newEntity);
  };

  /** * Get Data Suffix ***/

  const dataSuffix = entity.CompanySuffixes?.map((item) => ({
    ...item,
    value: item.name,
    label: item.name,
  }));
  const [suffixes, setSuffixes] = React.useState(dataSuffix[0]);

  useEffect(() => {
    if (entity && country) {
      setSuffixes(dataSuffix[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entity, country]);

  const onSelectSuffixes = (newSuffixes) => {
    setSuffixes(newSuffixes);
  };

  /** * OnSubmit ***/
  const onSubmit = async (data) => {
    const token = await recaptchaRef.current.executeAsync();

    if (token) {
      const GAUserID = getGAUserID();
      const dataSend = { ...data };

      dataSend.captcha_response = token;
      dataSend.client_id = GAUserID ? GAUserID : "";
      dataSend.website_id = process.env.NEXT_PUBLIC_WEBSITE_ID;
      dataSend.company_country_id = country.id;
      dataSend.company_suffix_id = suffixes.id;
      dataSend.company_suffix_name = suffixes.name;
      dataSend.entity_type_id = entity.id;
      // Data.contact_from_id = 3;
      try {
        axios;
        //   .post(
        //     `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/check_name`,
        //     Data,
        //     {
        //       Headers: {
        //         "captcha-response": token,
        //       },
        //     }
        // )
        sendData({
          api: `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/check_name`,
          data: dataSend,
          token,
        })
          .then((response) => {
            if (response.state) {
              trigger("contact_form", dataSend, `Check name - ${country.name}`);
              reset();
              setCountry(countryInit);
              openAlert(3000, "success");
              clearErrors();
            } else {
              openAlert(3000, "error");
              console.error();
            }
            setIsLoading(false);
          })
          .catch((error) => {
            openAlert(3000, "error");
            console.log(error);
          });
      } catch (e) {
        // Reset();
        clearErrors();
        openAlert(3000, "error");
        console.log("error", e);
      }
    } else {
      setIsLoading(false);
    }
  };

  /** ****/
  return (
    <div className={`${styles.wrapper}`}>
      <h5 className="mb-6 text-center text-lg font-semibold text-bbc-brand-700 lg:text-left">
        Your proposed business name
      </h5>

      <form onSubmit={handleSubmit(onSubmit)}>
        {/* select country */}

        <div className={"col-12 relative mb-4  "}>
          <p className="mb-4 font-medium text-bbc-brand-700">Nation*</p>
          <Dropdown
            isOpen={isOpen}
            onClose={() => setOpen(!isOpen)}
            target={
              <div
                className={`${
                  locationRouter === "hk" || locationRouter === "sg"
                    ? "pointer-events-none select-none"
                    : "cursor-pointer"
                } relative block h-10 w-full rounded-full border border-gray-300 bg-bbc-white px-4 py-2`}
                onClick={() => setOpen(!isOpen)}
                disabled={Boolean(
                  locationRouter === "hk" || locationRouter === "sg"
                )}
              >
                {country ? (
                  <div className="flex items-center ">
                    <Img
                      style={{ marginRight: 8, width: 25, height: 18 }}
                      src={`/assets/flags/4x3/${country.country_code.toLowerCase()}.svg`}
                      alt={`${country.name.toLowerCase()} flag`}
                    />

                    <span className="text-sm text-[#888]">{country.name}</span>
                  </div>
                ) : (
                  "Choose your country"
                )}
                {locationRouter === "hk" || locationRouter === "sg" ? null : (
                  <FiChevronDown className="absolute top-3 right-4" />
                )}
              </div>
            }
          >
            <Select
              className={styles.customSelectSearch}
              autoFocus
              backspaceRemovesValue={false}
              controlShouldRenderValue={false}
              hideSelectedOptions={false}
              isClearable={false}
              menuIsOpen
              options={countryList}
              placeholder="Search..."
              tabSelectsValue={false}
              value={country}
              styles={customSelectStylesNation}
              components={{
                Option: CustomOption,
                IndicatorSeparator: () => null,
                DropdownIndicator: IconSearch,
              }}
              onChange={handedOnchange}
            />
          </Dropdown>
        </div>

        {/* input  Entity Name */}

        <div className="col-12 mb-4">
          <p className="mb-4 font-medium text-bbc-brand-700">Entity Name*</p>
          <div className="mb-6">
            <input
              placeholder="Your proposed company name"
              type="text"
              {...register("company_name", {
                required: {
                  value: true,
                  message: "This field is required",
                },
              })}
              className="w-full rounded-full border border-gray-300 py-2 px-4 text-sm leading-6 text-bbc-gray placeholder-neutral-400 focus:ring-0"
            />

            {errors.company_name?.type === "required" && (
              <span className="block pl-2 pt-2 text-sm text-red-500">
                {errors.company_name?.message}
              </span>
            )}
          </div>
        </div>
        {/* Entity Type* and Suffixes */}
        <div className="row ">
          <div className={"mb-6  lg:col-6 lg:mb-10 "}>
            <p className="mb-4 font-medium text-bbc-brand-700">Entity Type*</p>
            <Select
              options={dataEntityType}
              value={entity}
              components={{
                Option: CustomOptionDropdown,
                IndicatorSeparator: () => null,
                DropdownIndicator,
              }}
              isSearchable={false}
              styles={customSelectStyles}
              onChange={onSelectEntity}
              onMenuClose={arrowDown}
            />
          </div>
          {/* Suffixes */}
          <div className={"mb-6  lg:col-6 lg:mb-10 "}>
            <p className="mb-4 font-medium text-bbc-brand-700">Suffixes*</p>
            <Select
              options={dataSuffix}
              value={suffixes}
              components={{
                Option: CustomOptionDropdown,
                IndicatorSeparator: () => null,
                DropdownIndicator,
              }}
              isSearchable={false}
              styles={customSelectStyles}
              onChange={onSelectSuffixes}
              onMenuClose={arrowDown}
            />
          </div>
        </div>

        <h5 className="mb-6 text-lg font-semibold text-bbc-brand-700">
          Tell us how we can communicate with you about the result
        </h5>

        {/* First Name* */}
        <div className="row">
          <div className="mb-6 lg:col-6">
            <p className="mb-4 font-medium text-bbc-brand-700">First Name*</p>
            <input
              {...register("first_name", {
                required: {
                  value: true,
                  message: "This field is required",
                },
              })}
              className={
                "w-full rounded-full border px-4  py-2 text-sm leading-6 text-bbc-gray  placeholder:text-sm focus:outline-none"
              }
              // Disabled={isSubmitting}
              type="text"
              placeholder="Ex: Christian"
            />

            <span className="block pt-2 pl-2 text-sm text-red-500">
              {errors.first_name?.message}
            </span>
          </div>
          {/* Last Name** */}
          <div className="mb-6 lg:col-6">
            <p className="mb-4 font-medium text-bbc-brand-700">Last Name</p>
            <input
              {...register("last_name")}
              className={
                "w-full rounded-full border px-4  py-2 text-sm leading-6 text-bbc-gray  placeholder:text-sm focus:outline-none"
              }
              disabled={isSubmitting}
              type="text"
              placeholder="Ex: Chan"
            />
          </div>
        </div>
        {/* Email Address* */}
        <div className="col-12 mb-6">
          <p className="mb-4 font-medium text-bbc-brand-700">Email Address*</p>
          <input
            {...register("email", {
              required: {
                value: true,
                message: "Email is required",
              },
              pattern: {
                value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
                message: "Invalid e-mail",
              },
            })}
            className={
              " w-full rounded-full border px-4  py-2 text-sm leading-6 text-bbc-gray  placeholder:text-sm focus:outline-none"
            }
            disabled={isSubmitting}
            type="email"
            placeholder="Ex: christian@gmail.com"
          />

          <span className="block pt-2 pl-2 text-sm text-red-500">
            {errors.email?.message}
          </span>
        </div>

        <div className="">
          <div className="mb-8">
            <i className="text-[12px]">*Note:</i>
            <br />
            <i className="text-[12px]">The information is required</i>
          </div>

          <div className="col-12 mb-6 flex items-end justify-center lg:col-7 lg:mb-0 lg:justify-start">
            <div className="inline-block overflow-hidden">
              <ReCaptcha ref={recaptchaRef} className="mx-auto w-max" />
            </div>
          </div>
          <div className="  mt-10 text-center">
            <ButtonNew
              id="form-contact-button"
              type="submit"
              onClick={() => {
                if (isSubmitting) setIsLoading(true);
              }}
              disabled={isLoading}
              btnDisplay={"inline-flex justify-center items-center"}
              othersClass="relative "
            >
              {isSubmitting ? (
                <span className="flex items-center pr-0 lg:pr-5">
                  <BiLoaderAlt
                    className="mr-2 inline-block animate-spin"
                    size={20}
                  />
                  <span className="pl-3">Loading</span>
                </span>
              ) : (
                "Send Your Message"
              )}
            </ButtonNew>
          </div>
        </div>
      </form>
    </div>
  );
};

export default FormCheckNameCompany;

/** ========== */
